import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

const CompanyLinedWhite = (props) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <G fill="#D4E5FE" clipPath="url(#a)">
      <Path d="M5.692 7.167h.85c.233 0 .425-.225.425-.5s-.192-.5-.425-.5h-.85c-.234 0-.425.225-.425.5s.191.5.425.5ZM8.484 7.167h.85c.233 0 .425-.225.425-.5s-.192-.5-.425-.5h-.85c-.234 0-.425.225-.425.5s.191.5.425.5ZM5.692 9.567h.85c.233 0 .425-.225.425-.5s-.192-.5-.425-.5h-.85c-.234 0-.425.225-.425.5s.191.5.425.5ZM8.484 9.567h.85c.233 0 .425-.225.425-.5s-.192-.5-.425-.5h-.85c-.234 0-.425.225-.425.5s.191.5.425.5Z" />
      <Path d="m15.95 7.4-4.283-.583V4.975c0-.617-.383-1.15-.925-1.3l-5.9-1.6a1.23 1.23 0 0 0-.292-.042v1.084l5.909 1.6c.05.016.125.116.125.258v2.517c0 .041-.025.083-.025.125v9.633h-.875v-3.842c0-.616-.5-1.108-1.109-1.108h-1.85c-.616 0-1.108.5-1.108 1.108v3.842h-1.2V3.375c0-.175.108-.258.133-.258V2.033c-.65 0-1.216.584-1.216 1.342v14.392c0 .316.233.566.516.566h12.117c.383 0 .7-.316.7-.7V8.225a.82.82 0 0 0-.717-.817V7.4Zm-7.266 9.85H6.617v-3.842a.11.11 0 0 1 .108-.108h1.85a.11.11 0 0 1 .109.108v3.842Zm6.9 0h-3.917V7.908l3.917.534v8.808Z" />
      <Path d="M13.117 10.5h1c.275 0 .5-.225.5-.5s-.225-.5-.5-.5h-1c-.275 0-.5.225-.5.5s.225.5.5.5ZM13.117 13.058h1c.275 0 .5-.225.5-.5s-.225-.5-.5-.5h-1c-.275 0-.5.225-.5.5s.225.5.5.5ZM14.108 14.7h-1c-.275 0-.5.225-.5.5s.225.5.5.5h1c.275 0 .5-.225.5-.5s-.225-.5-.5-.5Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h20v20H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)
export default CompanyLinedWhite
